import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {AttributeLambdaParameters} from "#template/nodes/geometry-graph/attribute/attribute-lambda/geometry-attribute-lambda-node"
import {
    GeometryAttributeLambdaNode,
    attributeLambdaParametersSchema,
} from "#template/nodes/geometry-graph/attribute/attribute-lambda/geometry-attribute-lambda-node"

export type CurveGeometryAttributeLambdaParameters = AttributeLambdaParameters<1>

const definition: TemplateNodeDefinition<CurveGeometryAttributeLambdaParameters> = {
    nodeClass: "CurveGeometryAttributeLambda",
    validation: {
        parameters: attributeLambdaParametersSchema<1>(),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryAttributeLambda
    extends GeometryAttributeLambdaNode<1, CurveGeometryAttributeLambdaParameters>
    implements CurveGeometryAttributeLikeNode
{
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
